// extracted by mini-css-extract-plugin
module.exports = {"image_wrapper":"product-thumbnail_image_wrapper__5OGTM"};